import {Injectable, Injector} from '@angular/core';
import {APlatformAppService} from "@shared/models/platform-app-service-base";
import {SharedUIService} from "@core/services/sharedui.service";
import {Configuration} from "@shared/models/configuration";
import {ApplicationIds} from "@shared/constants/common-field.constants";
import {select, Store} from "@ngrx/store";
import {SecurityState} from "@shared/store/reducers/security.reducer";
import {Observable, Subject} from "rxjs";
import {AuthApiService} from "@core/services/auth-api.service";
import {hasFeature} from "@shared/store/selectors/security.selector";
import {takeUntil} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AdminpanelAppService extends APlatformAppService{
  adminPanelFeatureId = 'AP';
  hasFeature$: Observable<any>;
  private ngUnsubscribe = new Subject<void>();
  constructor(public injector: Injector,
              public securityStore: Store<SecurityState>,
              public authApiService: AuthApiService,
              public sharedUIService: SharedUIService) {
    super(injector);
    this.platformLogoModel = {
      url: 'https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/logos/orbitax.svg',
      width: '86px',
      height: '20px',
      wrapperClass: 'particle-application-logo-hide-when-menu-appear'
    };

    if (window.location.hostname.includes('adminpanel')) {
      this.hasFeature$ = this.securityStore.pipe(select(hasFeature), takeUntil(this.ngUnsubscribe));
      this.hasFeature$.subscribe(feature => {
        if (feature) {
          let isUserHasAdminPanel = feature(this.adminPanelFeatureId) === true;
          console.log('User has AdminPanel? ', isUserHasAdminPanel);
          if (!isUserHasAdminPanel) {
            window.location.href = Configuration.getConfig('RootUrl');
          }
        }
      });
    }
  }

  getToolbarShortcutItems(): any[] {
    return [
      {
        'type'      : 'nav-item',
        'url'       : 'home',
        'displayTxt': 'Home',
        'key'       : 'platform-home',
        'title'     : 'Home'
      },
      {
        'type'      : 'nav-item',
        'url'       : 'administration/usage-report',
        'displayTxt': 'Usage Reports',
        'key'       : 'usage-report',
        'title'     : 'Usage Reports',
        'featureId': 'APUsageReport',
      }
    ];
  }
  getLogoAsStyle() {
    const logoStyle = super.getLogoAsStyle();
    logoStyle['background-position'] = 'center center';
    return logoStyle;
  }
  hasSpotlightSearchToolbar(){
    return false;
  }
  isEnabled(): boolean {
    return Configuration.ApplicationId === ApplicationIds.AdminPanel;
  }
  hasProjectToolbar() {
    return false;
  }
}
